export default "__VITE_ASSET__6186a2d8__"